import React from 'react';

export interface Sign1IconProps {}

export const Sign1Icon: React.FC<Sign1IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.674 3.28925L16.9839 12.2577C16.9702 12.4361 16.8623 12.5935 16.7009 12.6705C16.4695 12.7811 16.1956 12.698 16.0624 12.486L16.0342 12.4348L14.3055 8.81525L11.0251 12.0962C10.3687 12.7525 10 13.6428 10 14.571V21H7V14.571C7 12.8471 7.68482 11.1938 8.90381 9.97485L12.197 6.68125L8.52845 4.92907C8.38499 4.86055 8.28377 4.72856 8.25341 4.57483L8.2454 4.51624C8.22573 4.26058 8.40197 4.03506 8.64769 3.98718L8.70557 3.97936L17.674 3.28925Z"
        fill="#192033"
      />
    </svg>
  );
};
